import React from "react";
import AttendanceForm from "./components/AttendanceForm";

function App() {
  return (
    <div>
      <AttendanceForm />
    </div>
  );
}

export default App;
